module.exports = __webpack_public_path__ + "static/media/editTag_disabled.78af48b0.svg";